const menu = {
  key: "deliveryModes",
  route: "/legacy/delivery-modes",
  label: "sidebar.deliveryModes",
  icon: "faTruck",
  group: "configuration",
  order: 10,
  permission: "legacy.deliveryModes.read"
};

export default menu;